import config from '../config'
import http from '../http'

export default{

	bindReturnOrder:async function(payload) {
		const res = await http({
			url: config.BIND_STORE_RETURN,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	distributeOrder:async function(payload) {
		const res = await http({
			url: config.DISTRIBUTE_ORDER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	queryAllOrders:async function(payload) {
		const res = await http({
			url: config.QUERY_ORDERS_NEW,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	queryReturnOrder:async function(payload) {
		const res = await http({
			url: config.QUERY_RETURN_ORDERS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	queryReturnOrderNum:async function(payload) {
		const res = await http({
			url: config.QUERY_RETURN_ORDERS_NUM,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getDistrustOrders:async function(payload) {
		let res = await http({
			url: config.QUERY_ORDERS_NEW,
			method: 'post',	
			data: {
				...payload
			}
		})
		return res.data
	},
    updateCustomer:async function(payload) {
		const res = await http({
			url: config.UPDATA_CUSTOMER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	getVarationsById:async function(payload) {
		const res = await http({
			url: config.GET_SHOP_ITEMS_BY_IDS,
			method: 'post',
			data: payload
		})
		return res.data
	},
	
	getVarationsById:async function(payload) {
		const res = await http({
			url: config.GET_SHOP_ITEMS_BY_IDS,
			method: 'post',
			data: payload
		})
		return res.data
	},
	//卖家获取所有订单
	queryAllOrder:async function(payload) {
		const res = await http({
			url: config.QUERY_ORDERS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//重新加载订单
	reloadOrder: async function(payload) {
		const res = await http({
			url: config.RELOAD_ORDER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取待审核的订单信息 ---高级查询
	getUnaditorOrder: async function(payload) {
		const res = await http({
			url: config.GET_UNAUDIT_ORDERS,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	////卖家获取积分预扣
	getGoodsType: async function(payload) {
		const res = await http({
			url: config.GET_GOODS_TYPE,
			method: 'post',
			data: payload
		})
		return res.data
	},

	//获取测品仓的goodsType
	getGoodsTypeByStore: async function(payload) {
		const res = await http({
			url: config.GET_GOODS_TYPE_STORE,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//重新生成url地址
	regeneratePDF: async function(payload) {
		const res = await http({
			url: config.REGENERATE_PDF,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//积分变更信息查询
	getSellerPoint: async function(payload) {
		const res = await http({
			url: config.REFRESH_POINT,
			method: 'get',
			data: {
				...payload
			}
		})
		return res.data
	},
	//积分变更信息查询
	pointChange: async function(payload) {
		const res = await http({
			url: config.POINTS_CHANGE,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//填写物流单号
	logisticsNumber: async function(payload) {
		const res = await http({
			url: config.REVIVIEING_INFORMATION,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取仓库产品信息
	getstoreitembyid: async function(payload) {
		const res = await http({
			url: config.GET_STORE_ITEM_BY_ID,
			method: 'post',
			data: payload
			
	
		})
		return res.data
	},
	//查询订单信息
	OrderTracking: async function(payload) {
		const res = await http({
			url: config.ORDER_TRACKING,
			method: 'post',
			data: payload
	
		})
		return res.data
	},
	//创建支付宝订单
	createOrderalipay: async function(payload) {
		const res = await http({
			url: config.CREATE_ORDER_ALIPAY,
			method: 'post',
			data: payload
	
		})
		return res.data
	},
	
	//检查是否已支付
	checkOrderalipay: async function(payload) {
		const res = await http({
			url: config.CHECKED_ORDER_ALIPAY,
			method: 'get',
			data: payload
	
		})
		return res.data
	},
	//获取卖家订单商品种类数
	getSpeciesOrder: async function(payload) {
		const res = await http({
			url: config.GET_SPECIES_ORDER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//获取所有店铺待审核订单
	getPendingOrder: async function(payload) {
		const res = await http({
			url: config.GET_ALLSTORE_IN_STOREUSER,
			method: 'get',
			data: {
				userId: payload
			}
		})
		return res.data
	},
	
	//获取所有店铺待处理订单
	getUnprocessOrder: async function(payload) {
		const res = await http({
			url: config.GET_ALLSTORE_IN_STOREUSER,
			method: 'get',
			data: {
				userId: payload
			}
		})
		return res.data
	},
	
	//获取所有店铺已发货的订单
	getShippedOrder: async function(payload) {
		const res = await http({
			url: config.GET_ALLSTORE_IN_STOREUSER,
			method: 'get',
			data: {
				userId: payload
			}
		})
		return res.data
	},
	
	//获取所有店铺有问题的订单
	getProblemorder: async function(payload) {
		const res = await http({
			url: config.GET_ALLSTORE_IN_STOREUSER,
			method: 'get',
			data: {
				userId: payload
			}
		})
		return res.data
	},
	//获取所有店铺或某些商店的订单总数
	getOrderCountTotal: async function(payload) {
		const res = await http({
			url: config.GET_ORDER_TOTAL,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},

	hiddenOrder: async function(payload) {
		const res = await http({
			url: config.HIDDEN_ORDER,
			method: 'post',
			data: {
				...payload
			}
		})
		return res.data
	},
	//订单查找
	getOrdersBytrickNo:async function(payload) {
		console.log(payload)
		const res = await http({
			url: config.GET_ORDER_BY_TRICKNO,
			method: 'get',
			data: {
				orders:payload.orders
			}
		})
		return res.data
	},
	getOrdersBytrickNo_return:async function(payload) {
		console.log(payload)
		const res = await http({
			url: config.GET_ORDER_BY_TRICKNO_RETURN,
			method: 'get',
			data: {
				orders:payload.orders
			}
		})
		return res.data
	},
	//pick_up 批量生成运单号
	getInitOrderBypickup:async function(payload) {
		console.log("111",payload)
		const res = await http({
			url: config.PICK_OFF_ORDER,
			method: 'post',
			data:payload,
			timeout: 1000 * 10 * 1,
			
		})
		return res.data
	},
	//dropp_up 批量生成运单号
	getInitOrderBydropoff:async function(payload) {
		const res = await http({
			url: config.DROP_OFF_ORDER,
			method: 'post',
			data:payload,
			timeout: 1000 * 10 * 1,
			
		})
		return res.data
	},
	//订单号轮询查找运单号
	getTrackIngNoByOrdersn:async function(payload) {
		const res = await http({
			url: config.GET_ORDER_TRICKNO,
			method: 'get',
			data:{
				ordersn:payload.ordersn,
				shopId:payload.shopId
			}
		})
		return res.data
	},
	
	//同步最新订单
	updatShopAllOrders:async function(payload) {
		const res = await http({
			url: config.UPDATE_SHOP_ORDER_ALL,
			method: 'post',
			data:payload,
			
		})
		return res.data
	},
	//查看物流
	viewLogistics:async function(payload) {
		const res = await http({
			url: config.VIEW_LOGISTICS,
			method: 'post',
			data:payload,
			
		})
		return res.data
	},
	
	//取消审核 
	cancelReview:async function(payload) {
		const res = await http({
			url: config.CANCEL_REVIEW_SHOPEE,
			method: 'post',
			data:payload,
			
		})
		return res.data
	},
	//收到退货
	receiveReturn:async function(payload) {
		const res = await http({
			url: config.RECIEVE_RETUREN_GOODS,
			method: 'post',
			data:{
				...payload
			}
			
		})
		return res.data
	},
	//卖家确认
	sellerComfirm:async function(payload) {
		const res = await http({
			url: config.SELLER_COMFIRM,
			method: 'post',
			data:{
				...payload
			}
			
		})
		return res.data
	},
	//仓库处理
	storeComfirm:async function(payload) {
		const res = await http({
			url: config.STORE_COMFIRM,
			method: 'post',
			data:{
				...payload
			}
			
		})
		return res.data
	},
	
	//仅通过现货订单  继续全部通过
	reviewOrder:async function(payload) {
		const res = await http({
			url: config.GET_ORDER_REVIEW,
			method: 'post',
			data:payload
				
			
		})
		return res.data
	},
	
	//获取自动审核规则
	getAutoreviewrules:async function(payload) {
		const res = await http({
			url: config.GET_AUTOAUDITORE_RULE,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	//添加自动审核规则
	addAutoreviewrules:async function(payload) {
		const res = await http({
			url: config.ADD_AUTOAUDITORE_RULE,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	//删除自动审核规则
	delAutoreviewrules:async function(payload) {
		const res = await http({
			url: config.DEL_AUTOAUDITORE_RULE,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	//创建Payssion支付订单
	createPayorderByPayssion:async function(payload) {
		const res = await http({
			url: config.CREATE_ORDER_PAYSSION,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	//payssion支付回调
	checkPayOrderPayssion:async function(payload) {
		const res = await http({
			url: config.CHECKED_ORDER_PAYSSION,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},
	//创建微信支付订单
	createPayorderBywechat:async function(payload) {
		const res = await http({
			url: config.CREATE_ORDER_WECHAT,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	//轮询支付订单是滞成功
	checkPayOrder:async function(payload) {
		const res = await http({
			url: config.CHECKED_ORDER_WECHAT,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},
	//获取商品订单
	getGoodsOrder:async function(payload) {
		const res = await http({
			url: config.GET_GOODS_ORDER,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	//获取物流种类
	getLogistics:async function(payload) {
		const res = await http({
			url: config.GET_LOGISTICS,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	//增加打印次数
	addPrintTimes:async function(payload) {
		const res = await http({
			url: config.ADD_PRINT_TIMES,
			method: 'get',
			data:{
				...payload
			}
			
		})
		return res.data
	},
	//查看打印历史纪录
	getPrintSheetHistory:async function(payload) {
		const res = await http({
			url: config.GET_PROINT_SHEET_HISTORY,
			method: 'post',
			data:{
				...payload
			}
			
		})
		return res.data
	},
	
	//合并打印订单
	getPrintTogether:async function(payload) {
		const res = await http({
			url: config.GET_PRINT_TOGETHER,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	//新增代打包运单号
	addOrderPackage:async function(payload) {
		const res = await http({
			url: config.ADD_PACKAGE_ORDER,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	//根据打包运单号查询订单
	getOrderByPackageTrackingCode:async function(payload) {
		const res = await http({
			url: config.GET_ORDER_BY_PACKAGE_TRACKINGCODE,
			method: 'get',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	
	//仓库收到代打包运单
	storeReceived:async function(payload) {
		const res = await http({
			url: config.SOTRE_RECEIVED,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	//删除代打包的运单号
	deleteorderpackage:async function(payload) {
		const res = await http({
			url: config.DELTE_ORDER_PACKAGE,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	//批量下载打印图
	batchDownloadPrintDrawings:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_BATCHDOWNLOADPRINTDRAWINGS,
			method: 'post',
			responseType: 'blob',
			data:payload
		})
		return res.data
	},

	//扫描出库
	scanOutbound:async function(userId,token) {
		const res = await http({
			url: config.SHOPOEDER_SCANOUTBOUND+`?userId=${userId}&token=${token}`,
			method: 'post',
		})
		return res.data
	},
	
	//根据订单号同步订单
	updateShopOrdersById:async function(payload) {
		const res = await http({
			url: config.SHOPOEDER_UPDATESHOPORDERSBYID,
			method: 'post',
			data:{
				...payload
			}
		})
		return res.data
	},
	
	
	//根据订单号同步工厂出库状态
	getOutboundTime:async function(payload) {
		const res = await http({
			url: config.GET_OUTBOUND_TIME,
			method: 'post',
			data:payload
		})
		return res.data
	},
	
}